import React from 'react';
export function FooterSection() {
  return <footer className="py-12 px-4 border-t border-slate-800 bg-slate-950 text-center" role="contentinfo" data-id="element-64">
      <div className="max-w-4xl mx-auto space-y-4 text-slate-500 text-sm" data-id="element-65">
        <p data-id="element-66">
          © {new Date().getFullYear()} Mega Pack Gestión Organizacional — Todos
          los derechos reservados
        </p>
        <p data-id="element-67">Producto digital — Descarga inmediata — Garantía de 30 días</p>
      </div>
    </footer>;
}